// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGeocodeCachedRequest,
  TGeocodeCachedModel,
  IMappers,
  TGeocodeCachedResponse,
  TGeocodeCachedResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGeocodeCachedModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'GET',
  microserviceName: 'geo',
  pathApi: '/v1/geocode-cached/',
  interserviceAuthEnabled: true,
} as TGeocodeCachedModel;

export function createGeocodeCachedModel(parameters: IGeocodeCachedRequest): TGeocodeCachedModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGeocodeCachedOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IGeocodeCachedRequest;
}

export async function fetchGeocodeCached<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGeocodeCachedOptions<TResponse200>): Promise<TGeocodeCachedResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createGeocodeCachedModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGeocodeCachedResponse_1);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGeocodeCachedResponse;
}
